export default "__VITE_ASSET__DDc$vV0X__"